export class ConsultaGerencial {
    idGeral: string;
    cdAcesso: string;
    cdFilial: number;
    ordem: number;
    cdUsuario: number;
    tituloConsulta: string;
    flAtivo: boolean;
    descricao: string;
    dtAtz: Date;
}

export class ConsultaGerencialResponse {
    nmCampo: string;
    descricao: string;
    valor: string;
}